export const strings = {
  failedRulesTableHeaders: ['Failed Rule', 'Category', 'Priority'],
  failedRulesFound: 'Some rules have failed to run ',
  failedRulesAmount: numberOfFailedRules => `Failed rules: ${numberOfFailedRules}`,
  failedRulesPresentMessage: 'When rolling this period forward some rules have failed to run. You can view a list of these failed rules below. ',
  continue: 'Continue',
};